/** Firebase client config for HealBid Web (project: heal-bid). Public by design. */
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDmq2ewsTwSim8xnfzr9G4IaJ0Ua6rXW78",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "heal-bid.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "heal-bid",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "heal-bid.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "267724986680",
  appId:
    process.env.REACT_APP_FIREBASE_APP_ID || "1:267724986680:web:5ab1d67276521b505689cd",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-H228053S2G",
};

/** Web Push certificate (VAPID) from Firebase Console → Project settings → Cloud Messaging. */
export const firebaseVapidKey = (process.env.REACT_APP_FIREBASE_VAPID_KEY || "").trim();

export const FIREBASE_FCM_TOKEN_KEY = "healbid_web_fcm_token";
